// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dialog .el-dialog__header {\n  border-bottom: none;\n}\n", ""]);
// Exports
module.exports = exports;
